import { SECTIONS, type SectionId } from './types';
import { useT } from '../../i18n';
import { haptic } from '../../telegram';
import { useBadgeCount } from '../../sectionBadges';

export function SectionNav({
  active,
  onSelect,
}: {
  active: SectionId;
  onSelect: (id: SectionId) => void;
}) {
  const { t } = useT();
  const statsBadge = useBadgeCount('stats');
  const codexBadge = useBadgeCount('codex');

  return (
    <nav className="nav" role="tablist">
      {SECTIONS.map((s) => {
        const isActive = s.id === active;
        return (
          <button
            key={s.id}
            role="tab"
            aria-selected={isActive}
            className="nav-btn"
            onClick={() => {
              haptic.tick();
              onSelect(s.id);
            }}
          >
            <span aria-hidden="true" style={{ fontSize: '1.2rem' }}>{s.icon}</span>
            <span>{t(s.labelKey)}</span>

            {s.id === 'stats' && statsBadge > 0 && (
              <span
                aria-label={`${statsBadge} new`}
                style={{
                  position: 'absolute',
                  top: 4,
                  right: '20%',
                  minWidth: 14,
                  height: 14,
                  borderRadius: 7,
                  background: '#ff4a4a',
                  color: '#fff',
                  fontSize: '0.55rem',
                  fontWeight: 'bold',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '0 4px',
                  boxShadow: '0 0 6px #ff4a4a',
                  animation: 'pulse-glow 1.5s ease-in-out infinite',
                }}
              >
                {statsBadge}
              </span>
            )}
            {s.id === 'codex' && codexBadge > 0 && (
              <span
                aria-label={`${codexBadge} new`}
                style={{
                  position: 'absolute',
                  top: 4,
                  right: '20%',
                  minWidth: 14,
                  height: 14,
                  borderRadius: 7,
                  background: '#ffd866',
                  color: '#07090f',
                  fontSize: '0.55rem',
                  fontWeight: 'bold',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '0 4px',
                  boxShadow: '0 0 6px rgba(255,216,102,0.6)',
                  animation: 'pulse-glow 1.5s ease-in-out infinite',
                }}
              >
                {codexBadge}
              </span>
            )}
          </button>
        );
      })}
    </nav>
  );
}
